import { formatMoney } from '../components/utilities';

const Shipping = {
  form: document.querySelector('[data-shipping-form]'),
  input: document.querySelector('[data-shipping-form] input[name="cep"]'),
  button: document.querySelector('[data-shipping-form] button[type="submit"]'),
  results: document.querySelector('[data-shipping-form] [data-shipping-results]'),

  // handle input keydown
  keydown: function () {
    if (this.input) this.input.addEventListener('keydown', function (e) {

      // fix 'CEP' value
      let x = e.target.value.replace(/\D/g, '').match(/(\d{0,5})(\d{0,3})/);

      // set input value
      e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2];
    });
  },

  // handle form submit
  submit: function () {
    const _this = this;

    _this.form.addEventListener('submit', function (e) {
      e.preventDefault();

      let product = document.querySelector('[data-section-product]'),
          sku = product.querySelector('[name="sku"]').value,      
          quantity = product.querySelector('[name="quantity"]') ? product.querySelector('[name="quantity"]').value : 1,
          zipcode = _this.input.value;
          
      zipcode = zipcode.replace('-', '');

      if (zipcode.length == 8) {
        $.ajax({
          url: '/frete_produto',
          cache: false,
          type: 'POST',
          dataType: 'json',
          data: {
            sku: sku,
            zip: zipcode,
            quantity: quantity
          },
          beforeSend: () => {
            _this.form.classList.add('-sending');
          },
        })
        .done(function (resp) {
          console.log('resp', resp);

          let methods = JSON.parse(resp.methods),
              result = `<p class="address">${resp.address_details.street_name}, ${resp.address_details.neighborhood} - ${resp.address_details.city}/${resp.address_details.state}</p>`

          result += `<div class="results">`
          // PAC + SEDEX
          if (methods.length > 0) methods.forEach(method => {
            if (method.name == 'PAC' || method.name == 'SEDEX') {
              let price = method.price,
                  free = '';  
              free = price == 0 ? '-free' : '';
              price = price == 0 ? 'GRÁTIS' : formatMoney(price);
              result += `
                <div class="result">
                  <p class="infos">
                    <strong>
                      ${method.name}
                    </strong>
                    <span>
                      ${price}
                    </span>
                  </p>
                  <p class="text">
                    ${method.description}
                  </p>
                </div>
              `
            }
          });
          if (methods.length > 0) methods.forEach(method => {
            if (method.name != 'PAC' && method.name != 'SEDEX') {
              let price = method.price,
                  free = '';  
              free = price == 0 ? '-free' : '';
              price = price == 0 ? 'GRÁTIS' : formatMoney(price);
              result += `
                <div class="result">
                  <p class="infos">
                    <strong>
                      ${method.name}
                    </strong>
                    <span>
                      ${price}
                    </span>
                  </p>
                  <p class="text">
                    ${method.description}
                  </p>
                </div>
              `
            }
          });
          // DEFAULT
          result += `</div>`
          
          _this.results.innerHTML = result;
          _this.results.classList.remove('-empty');
          _this.results.classList.add('-visible');
        })
        .fail(function (error) {
          if (zipcode == '99999999') {
            _this.results.innerHTML = `
              <p class="address">
                Nome da Rua, Bairro - Cidade/Estado
              </p>
              <div class="results">
                <div class="result">
                  <p class="infos">
                    <strong>CSS</strong><span>GRÁTIS</span>
                  </p>
                  <p class="text">
                    Prazo de até 14 dias corridos para a entrega do pedido
                  </p>
                </div>
                <div class="result">
                  <p class="infos">
                    <strong>Sedex</strong><span>R$ 17,00</span>
                  </p>
                  <p class="text">
                    Prazo de até 11 dias corridos para a entrega do pedido
                  </p>
                </div>
                <div class="result">
                  <p class="infos">
                    <strong>Express</strong><span>R$ 24,00</span>
                  </p>
                  <p class="text">
                    Prazo de até 7 dias corridos para a entrega do pedido
                  </p>
                </div>
              </div>
            `
            _this.results.classList.add('-visible');
          } else {
            _this.results.innerHTML = '<p class="empty">Ocorreu um erro.</p>';
            _this.results.classList.add('-empty');
            _this.results.classList.add('-visible');
          }
        })
        .always(function(){
          _this.form.classList.remove('-sending');
        })
      } else {
        _this.results.innerHTML = '<p class="empty">Formato de CEP inválido.</p>';
        _this.results.classList.add('-empty');
        _this.results.classList.add('-visible');
      }
    });
  },

  init: function () {
    if (this.form) {
      this.keydown();
      this.submit();
    }
  }
}

export default Shipping;
